/// ==============================================
// Filename:PageNotFound.tsx
// Type: Component
// Last Updated: JULY 06, 2023
// Project: TELIMART - Front End
// ==============================================

// |-- Built-in Dependencies --|
import React from 'react'

const PageNotFound = () => {
    return (
        <div className="h-[100vh] w-full flex gap-2 justify-center items-center bg-white ">
            <h1>400 </h1>
            <h1> Page Not Found</h1>
        </div>
    )
}

export default PageNotFound
